export function isQrActive(qr) {
  const raw = qr?.status ?? qr?.isActive ?? qr?.active ?? qr?.enabled;
  if (raw === undefined || raw === null || raw === "") return true;
  if (typeof raw === "boolean") return raw;
  const status = String(raw).toLowerCase();
  return !["inactive", "disabled", "off", "false", "0"].includes(status);
}
